import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

  
export default function Maps() {
    const { t } = useTranslation();
    const [isSmall, setIsSmall] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 640px)');
        const handleChange = () => setIsSmall(!mediaQuery.matches);
        mediaQuery.addEventListener('change', handleChange);
        handleChange();
    }, []);

    var map_css = {width:"50%", borderTopRightRadius: "12px", borderBottomRightRadius: "12px" };
    var styles="rounded-l-xl w-80";
    if(isSmall){
        styles = "rounded-t-xl";
        map_css = {width:"100%", borderBottomLeftRadius: "12px", borderBottomRightRadius: "12px"};
    }


    return (
        <div class="lg:mx-24 mt-5 p-5 sm:flex justify-center">  
            <div class={"content-center bg-white bg-opacity-95 block p-6 bg-white shadow-sm " + styles}>
                <div>
                    <h1 class="text-xl font-bold fade-in-up">{t("where_find_us")}</h1>
                    <div class="pl-2">
                        <p class="text-lg font-bold pb-2">{t("main_company")}</p>
                        <p class="text-lg">Brněnská 1748/21b </p>
                        <p class="text-lg  pb-2">678 01 Blansko, Czech Republic</p>
                        <p class="pb-2 text-lg">{t("self_resp_where")}</p>
                    </div>
                </div>
            </div>
            <iframe class="h-64 2xl:h-96" style={{border:"none", ...map_css,background:"#e6e2d9" }} src="https://mapy.com/s/monebekufo" frameborder="0"></iframe>
        </div>

    )
}